export default {
  data() {
    return {
      itemList: [{
        icon: require('../../assets/气象站.png'),
        name: '气象站',
        value: '1套'
      }, {
        icon: require('../../assets/放风棉被机.png'),
        name: '放风棉被机',
        value: '30套'
      }, {
        icon: require('../../assets/水肥一体化.png'),
        name: '水肥一体化',
        value: '6套'
      }, {
        icon: require('../../assets/二氧化碳机.png'),
        name: '二氧化碳机',
        value: '2套'
      }, {
        icon: require('../../assets/自动喷灌机.png'),
        name: '自动喷灌机',
        value: '6套'
      }, {
        icon: require('../../assets/补光灯.png'),
        name: '补光灯',
        value: '7套'
      }, {
        icon: require('../../assets/视频监控.png'),
        name: '视频监控',
        value: '1套'
      }, {
        icon: require('../../assets/喷淋.png'),
        name: '喷淋',
        value: '71套'
      }, {
        icon: require('../../assets/水源热泵机组.png'),
        name: '水源热泵机组',
        value: '1套'
      }, {
        icon: require('../../assets/环流风机.png'),
        name: '环流风机',
        value: '2套'
      }]
    };
  }
};